import { api } from "../../app/api";
import { BASE_API } from "../../constants/apiUrls";
import {
  GetDashboardTopTradersParams,
  GetDashboardTopTradersResponseType,
  GetTraderListResponseType,
  GetTradersListParams,
  GetTradersSummeryParams,
  GetTradersSummeryResponseType,
} from "../../types/trader.type";

export const traderApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardTopTraders: builder.query<
      GetDashboardTopTradersResponseType,
      GetDashboardTopTradersParams
    >({
      query: (queries) => {
        return {
          url: BASE_API.getTopTraders,
          params: { ...queries },
        };
      },
    }),
    getTraderList: builder.query<
      GetTraderListResponseType,
      GetTradersListParams
    >({
      query: (queries) => {
        console.log(queries);
        return {
          url: BASE_API.getTraderList,
          params: { ...queries },
        };
      },
    }),
    getTradersSummery: builder.query<
      GetTradersSummeryResponseType,
      GetTradersSummeryParams
    >({
      query: (queries) => {
        return {
          url: BASE_API.getTradersSummery,
          params: { ...queries },
        };
      },
    }),
  }),
});

export const {
  useGetDashboardTopTradersQuery,
  useGetTraderListQuery,
  useGetTradersSummeryQuery,
} = traderApi;
